import { inlineSvg, packUrl } from './svg.js';

/**
 * The pups' own badges.
 *
 * The tag on a car used to be a coloured disc with a white paw - colour first, shape second, no reading -
 * and colour is still the cue that does the work. But she does not have to *learn* these: the badge on
 * Skye's card is the badge on Skye, and a three-year-old who knows the show recognises all eight before she
 * can name one of them.
 *
 * A file per pup at `badges/<pupId>.svg`, keyed off the same `pupId` that says who drives which vehicle
 * (`src/content/vehicles.ts`), so the pack stays swappable one pup at a time and there is no second
 * mapping to keep in step.
 *
 * These eight are show art rather than the pack's usual originals - see the note in the manifest and the IP
 * paragraph in docs/DESIGN.md. They live behind the manifest with everything else IP-derived, which is what
 * keeps a shareable build an asset swap.
 */
export function badgeArtUrl(pupId: string): string {
  return packUrl('badges', pupId);
}

/**
 * An inline `<svg>`, or null.
 *
 * Null is the ordinary outcome rather than an error to handle: `badgeElement` has already drawn the disc,
 * so a missing file costs the badge its detail and never costs her the picture that says whose car this is.
 */
export function badgeArtElement(pupId: string): Promise<SVGSVGElement | null> {
  return inlineSvg(badgeArtUrl(pupId));
}
